<template>
  <v-container fluid grid-list-md>
    <v-layout row wrap v-if='!dialog'>
      <v-flex
      v-bind="{ [`xs${channel.flex}`]: true }"
      v-for = "channel in tabComponents"
      :key = 'channel.title'
      >
      <v-card>
        <v-container fluid grid-list-lg>
          <v-layout row>
            <v-flex xs5>
              <div class='title' v-text='channel.title'>
              </div>
          </v-flex>
          <v-flex>
            <v-card-media
            :src='channel.src'
            height = '100px'
            contain
            >
          </v-card-media>
        </v-flex>
      </v-layout>
    </v-container>
    <v-card-actions>
      <v-btn flat @click.native.stop='openChannelDialog(channel)'> Open channel </v-btn>
    </v-card-actions>
  </v-card>
</v-flex>
</v-layout>
<!-- <v-bottom-sheet
  v-model='dialog'
  transition='dialog-bottom-transition'
  v-bind:hide-overlay='true'
> -->
  <v-card v-else>
    <v-toolbar class="theme--dark primary">
      <v-btn icon @click.native='closeChannelDialog' dark>
        <v-icon>close</v-icon>
      </v-btn>
      <v-toolbar-title>{{$route.params.projectid}} {{$route.params.channelID}}</v-toolbar-title>
    </v-toolbar>
    <router-view> </router-view>
  </v-card>
<!-- </v-bottom-sheet> -->
</v-container>
</template>

<script>
import {mapGetters} from 'vuex'
export default {
  name: 'data-channel-selector',
  data () {
    return {
      dataChannel: [
        { title: 'Wells', src: '/static/WellsCardImage2.png', dataLocation: 'well', flex: 4 },
        { title: 'Well Chemistry', src: '/static/WellChemCard.png', dataLocation: 'water chemistry', flex: 4 },
        { title: 'Weather Stations', src: '/static/WxStationMapsCard.png', dataLocation: 'weather station', flex: 4 },
        { title: 'Water Level', src: '/static/WaterLevelCard.png', dataLocation: 'water level', flex: 4 }
      ],
      dialog: false
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.dialog = (this.$route.name !== 'DataEntry')
    })
  },
  computed: {
    ...mapGetters('project', {
      project: 'selectedProject'
    }),
    routeName () {
      return this.$route.name
    },
    tabComponents () {
      var componentList = []
      for (let componentName in this.project.components) {
        let component = this.project.components[componentName]
        if (component.tab === 'Data') {
          // temporaroly storing lookup key for routing purposes
          component['fbkey'] = componentName
          componentList.push(component)
        }
      }
      return componentList
    }
  },
  watch: {
    routeName (value) {
      this.dialog = (value !== 'DataEntry')
    }
  },
  methods: {
    closeChannelDialog () {
      this.dialog = false
      this.$router.replace({name: 'DataEntry', params: {projectid: this.$route.params.projectid}})
    },
    openChannelDialog (channel) {
      this.$router.push({name: channel.component, params: {projectid: this.$route.params.projectid, channelID: channel.fbkey}})
      this.dialog = true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/project/DataChannelSelector.vue